import EditLicensePrevSub from './EditLicensePrevSub'

export default EditLicensePrevSub



// WEBPACK FOOTER //
// ./src/components/EditLicensePrevSub/index.js